export const SHOWROOMS = [
  {
    id: "mg-road",
    label: "Showroom 1",
    name: "Sikanderpur Marble Market",
    link: "https://maps.app.goo.gl/ks7NUEVYnGcTqwZ5A",
    cid: "17816192954593145644",
    address:
      "420, Mehrauli-Gurgaon Rd, Opp. Metro Pillar No. 6, Near Arjan Garh, Gurugram, Haryana 122001",
  },
  {
    id: "marble-market",
    label: "Showroom 2",
    name: "HUDA Marble Market Sector 33-34",
    link: "https://maps.app.goo.gl/wfpth9n32BbcaeNZ6",
    cid: "18126781863596882071",
    address: "Plot No 16, Marble Market, Sector 33-34, Near Honda Chowk, Gurugram, Haryana 122002",
  },
];

export const mapsUrl = (address) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
    "Varun Marbles " + address
  )}`;

// Embed by exact Google place CID so the correct listing's info card opens
// directly (address-text searches show duplicate nearby listings instead).
export const mapsEmbedUrl = (showroom) =>
  showroom.cid
    ? `https://www.google.com/maps?cid=${showroom.cid}&output=embed`
    : `https://www.google.com/maps?q=${encodeURIComponent(
        "Varun Marbles " + showroom.address
      )}&output=embed`;
